var rimraf = require('rimraf')

function removeSync (dir) {
  return rimraf.sync(dir)
}

function remove (dir, callback) {
  return callback ? rimraf(dir, callback) : rimraf(dir, function () {})
}

module.exports = {
  remove: remove,
  removeSync: removeSync
}



//////////////////
// WEBPACK FOOTER
// ./~/github-download/~/fs-extra/lib/remove/index.js
// module id = 355
// module chunks = 0